import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SortEvent } from 'primeng/api';
import { ModalReturnData, ModalService } from '@card-software/library';
import { Address } from '../../../models/address/address';
import { AddressDetailModalComponent } from '../modals/address-detail-modal.component/address-detail-modal.component';
import { globalSortFunction } from '../../../utilities';

@Component({
  selector: 'app-addresses-viewer',
  templateUrl: './addresses-viewer.component.html',
})
export class AddressesViewerComponent {
  @Input() addresses: Address[] = [];
  @Input() viewOnly = true;

  @Output() addressesChange = new EventEmitter<Address[]>();

  constructor(private modalService: ModalService) {}
  openModalAddress(address: Address | null = null): void {
    const newAddress = address ?? {};

    const index = address ? this.addresses.indexOf(address) : -1;

    this.modalService
      .open(AddressDetailModalComponent, {}, { address: { ...newAddress } })
      .subscribe((result: ModalReturnData<Address | null>) => {
        if (result.action !== 'Save' || !result.data) return;

        const updatedAddress = { ...result.data };

        if (index >= 0) {
          this.addresses[index] = updatedAddress;
        } else {
          this.addresses.push(updatedAddress);
        }

        this.addresses = [...this.addresses];
        this.addressesChange.emit(this.addresses);
      });
  }

  onTableSort(event: SortEvent): void {
    globalSortFunction<Address>(event, ['code']);
  }
}
